'use strict';

const Backbone = require('backbone');
const polyglot = require('../utilities/polyglot').default;

export default Backbone.Model.extend({
  isMultipleChoice: function() {
    return this.get('type') === 1;
  },

  isText: function () {
    return this.get('type') === 2;
  },

  validate: function() {
    const required = this.get('required');
    const errors = { questionId: this.id };
    const hasErrors = required && !this.get('value');

    if (hasErrors) {
      errors.message = polyglot.t('forms.required.error');

      return errors;
    }
  },

  /**
   * DOM element for the input.
   *
   * @return {HTMLElement}
   */
  element: function () {
    return document.getElementById(`custom-question-${this.get('id')}`);
  },

  /**
   * DOM element for additional input.
   *
   * @return {HTMLElement}
   */
  additionalInputElement: function () {
    return document.getElementById(`custom-question-${this.get('id')}-additional-input`);
  },

  /**
   * Retrieve the value of user's input.
   *
   * @return {String|NULL}
   */
  getValue: function () {
    if (this.isMultipleChoice() && this.additionalInputElement()) {
      return this.additionalInputElement().value;
    }
    if (this.isText()) {
      return this.element().value;
    }
  },

  /**
   * Get the ID of the selected option for multiple choice questions.
   *
   * @return {String|NULL}
   */
  getFormOptionId: function () {
    if (this.isMultipleChoice() && this.element().value !== null) {
      return this.element().value;
    }
  },

  /**
   * Transform the form object into a response object.
   *
   * @return {Object}
   */
  toResponse: function () {
    return {
      form_question_id: this.get('id'),
      form_option_id: this.getFormOptionId(),
      value: this.getValue(),
    };
  },
});
